import {bufferTime, catchError, distinct, filter, map, mergeMap, switchMap, takeUntil, tap} from 'rxjs/operators';
import {from, interval, of, concat, EMPTY} from 'rxjs';
import {combineEpics, ofType} from 'redux-observable';
import * as R from 'ramda';
import {
  authPoll,
  networkError,
  SET_AUTH_DATA,
  SET_AUTHENTICATED_USER,
  SET_EMULATED_USER,
  START_AUTH_POLL, STOP_AUTH_POLL,
  uiError
} from "../actions/ui";
import {
  addUsers,
  API_GET_USER,
  API_GET_USERS_DONE,
  getUsersDone, getUsers, clearUserSearch, getMyProfile
} from '../actions/users';
import {getUserByQuery$, getUserMulti$} from "../services/users";
import {
  catchErrorsandResume,
  INDIVIDUAL_ID_BUFFER_MS,
  INDIVIDUAL_ID_FETCH_SIZE,
  MODEL_INSERTION_BUFFER_INTERVAL_MS,
  requestDedupInterval$
} from "./index";

const getUsersMultiEpic = action$ => action$.pipe(
  ofType(API_GET_USER),
  distinct(action => action.payload.id, requestDedupInterval$),
  bufferTime(INDIVIDUAL_ID_BUFFER_MS, null, INDIVIDUAL_ID_FETCH_SIZE),
  filter(actions => actions.length > 0),
  mergeMap(actions => getUserMulti$({ ids: actions.map(action => action.payload.id) }).pipe(
    mergeMap(({response}) => from(response.results.map(item => getUsersDone(item)))),
    catchError(error => of(networkError({...error, number: '10107-'+error.status})))
  )),
  catchErrorsandResume(20074)
);

const processUsersEpic = action$ => action$.pipe(
  ofType(API_GET_USERS_DONE),
  map(action => action.payload),
  bufferTime(MODEL_INSERTION_BUFFER_INTERVAL_MS),
  filter(results => results.length > 0),
  map(results => addUsers(results)),
  catchErrorsandResume(20075)
);

// const searchUserEpic = action$ => action$.pipe(
//   ofType(API_GET_USER_QUERY),
//   switchMap(action => {
//     const { query } = action.payload;
//     if (!query) return of(clearUserSearch());
//     return getUserByQuery$({ query: action.payload.query }).pipe(
//       map(response => getUsersQueryDone(response)),
//       catchError(error => of(networkError(error)))
//     );
//   }),
//   catchErrorsandResume
// );

const updateLoggedInUser = action$ => action$.pipe(
  ofType(SET_AUTHENTICATED_USER),
  map(action => getUsers(action.payload.user)),
  catchErrorsandResume(20077)
);

const updateEmulatedUser = action$ => action$.pipe(
  ofType(SET_EMULATED_USER),
  map(action => getUsers(action.payload.user)),
  catchErrorsandResume(20076)
);

// Ensure user profile is loaded into redux state at least once if authenticated
const updateProfile = (action$, state$) => action$.pipe(
  ofType(SET_AUTH_DATA),
  filter(() => R.view(R.lensPath(['ui', 'authState']), state$.value) === 'signedIn' && R.isEmpty(state$.value.profile)),
  map(() => getMyProfile()),
  catchErrorsandResume(20078)
);

let pollerRunning = false;
const authPollInterval = (action$, state$) => action$.pipe(
  ofType(START_AUTH_POLL),
  filter(() => !pollerRunning),
  tap(() => pollerRunning = true),
  mergeMap(action => interval(20 * 1000).pipe(
    map(_ => authPoll()),
    takeUntil(action$.pipe(
      ofType(STOP_AUTH_POLL)
    ))
  ))
);

export const usersEpic = combineEpics(
  getUsersMultiEpic,
  // searchUserEpic,
  authPollInterval,
  updateProfile,
  processUsersEpic,
  updateLoggedInUser,
);



// WEBPACK FOOTER //
// ./src/network/users.js